export const DEFAULT_COMPANY_CONFIG = {
	'name': 'Kwong On Home For Elderly (Yuen Long) Limited',
	'url': 'https://erp.kwongonhomeyuenlong.com',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg',
  'serial_no': 'SYS-03'
}